let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iwXdr")).then(() => parcelRequire('aWUbc'));